// assets
import { IconBuildingBridge, IconBuildingCommunity, IconTractor, IconBucket, IconPlug, IconSchool } from '@tabler/icons-react';

// constant
const icons = {
    IconBuildingBridge,
    IconBuildingCommunity,
    IconTractor,
    IconBucket,
    IconPlug,
    IconSchool
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const lubombo = {
    id: 'lubombo',
    title: 'LUBOMBO',
    caption: 'Lubombo',
    type: 'group',
    children: [
        {
            id: 'dashboard-lubombo',
            title: 'Dashboard',
            type: 'item',
            url: '/civils/dashboard/lubombo',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'project-overview',
            title: 'Project Overview',
            type: 'collapse',
            icon: icons.IconBuildingBridge,

            children: [
                {
                    id: 'lowLevelCrossing',
                    title: 'Low Level Crossings',
                    type: 'item',
                    url: '/civils/lubombo/low-level-crossing',
                    target: false
                },
                {
                    id: 'footbridges',
                    title: 'Foot Bridges',
                    type: 'item',
                    url: '/civils/lubombo/foot-bridges',
                    target: false
                },
                {
                    id: 'roads',
                    title: 'Roads',
                    type: 'item',
                    url: '/civils/lubombo/roads',
                    target: false
                },
                {
                    id: 'halls',
                    title: 'Commuinity Halls',
                    type: 'item',
                    url: '/civils/lubombo/community-halls',
                    target: false
                }
            ]
        }
    ]
};

export default lubombo;
